import React from 'react';
import KanbanCard from '../KanbanCard';
import { useDroppable } from '@dnd-kit/core';
import { Globe, ArrowRight, X, Package } from 'lucide-react';

const SiteCard = ({ site, onUnassign, onClick, isSelected = false }) => {
  const isAssigned = !!site.clientId;
  const accountCount = site.accountIds?.length || 0;

  // Zone de drop pour recevoir des comptes
  const { isOver, setNodeRef } = useDroppable({
    id: `site-drop-${site.id}`,
    data: {
      type: 'site-drop-zone',
      siteId: site.id,
      accepts: ['account']
    }
  });

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '0.375rem'
  };

  const iconStyle = {
    width: '24px',
    height: '24px',
    borderRadius: '0.375rem',
    backgroundColor: '#f3efe7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#64748b',
    flexShrink: 0
  };

  const nameStyle = {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#1e293b',
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const descriptionStyle = {
    fontSize: '0.75rem',
    color: '#64748b',
    marginBottom: '0.5rem',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  };

  const statsRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    marginBottom: '0.5rem'
  };

  const statBadgeStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontSize: '0.7rem',
    color: '#64748b',
    backgroundColor: '#f3efe7',
    padding: '0.125rem 0.375rem',
    borderRadius: '0.25rem'
  };

  const associationStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.375rem 0.5rem',
    backgroundColor: isAssigned ? '#f0fdf4' : '#f3efe7',
    borderRadius: '0.375rem',
    marginTop: '0.5rem'
  };

  const associationTextStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
    fontSize: '0.75rem',
    color: isAssigned ? '#16a34a' : '#94a3b8'
  };

  const unassignButtonStyle = {
    padding: '0.125rem',
    borderRadius: '0.25rem',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    color: '#94a3b8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s'
  };

  const dropZoneStyle = {
    border: isOver ? '2px dashed #1a1a1a' : '2px dashed transparent',
    borderRadius: '0.375rem',
    backgroundColor: isOver ? '#dbeafe' : 'transparent',
    padding: isOver ? '0.25rem' : '0',
    margin: isOver ? '-0.25rem' : '0',
    transition: 'all 0.2s ease'
  };

  return (
    <div ref={setNodeRef} style={dropZoneStyle}>
      <KanbanCard
        id={site.id}
        type="site"
        data={site}
        draggable={true}
        onClick={onClick}
        isSelected={isSelected}
      >
        <div>
          <div style={headerStyle}>
            <div style={iconStyle}>
              <Globe size={14} />
            </div>
            <div style={nameStyle} title={site.name}>
              {site.name}
            </div>
          </div>

          {site.description && (
            <div style={descriptionStyle} title={site.description}>
              {site.description}
            </div>
          )}

          <div style={statsRowStyle}>
            <div style={statBadgeStyle}>
              <Package size={10} />
              <span>{accountCount} compte{accountCount !== 1 ? 's' : ''}</span>
            </div>
          </div>

          <div style={associationStyle}>
            <div style={associationTextStyle}>
              <ArrowRight size={12} />
              {isAssigned ? (
                <span>{site.clientName}</span>
              ) : (
                <span style={{ fontStyle: 'italic' }}>Non assigné</span>
              )}
            </div>

            {isAssigned && onUnassign && (
              <button
                style={unassignButtonStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  onUnassign(site.id);
                }}
                title="Retirer du client"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#fee2e2';
                  e.currentTarget.style.color = '#dc2626';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#94a3b8';
                }}
              >
                <X size={12} />
              </button>
            )}
          </div>
        </div>
      </KanbanCard>
    </div>
  );
};

export default SiteCard;
